import {Paper, styled} from '@mui/material';

// Paper com faixa colorida no topo e sombra suave
export default styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'color',
})(({theme, color}) => ({
    'position': 'relative',
    'backgroundColor': theme.palette.background.paper,
    'borderRadius': theme.shape.borderRadius * 1.5,
    'padding': theme.spacing(3),
    'marginBottom': theme.spacing(4),
    'boxShadow': theme.shadows[2],
    'overflow': 'visible',
    '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 4,
        backgroundColor: color,
    },
}));
